export const SET_CARDS = 'viewer/cards/SET_CARDS';
export const SET_PAGINATION = 'viewer/cards/SET_PAGINATION';
export const SET_CARD = 'viewer/cards/SET_CARD';
export const SET_CORECONCEPT = 'viewer/cards/SET_CORECONCEPT';
